import { IHeaderAction, IHeaderActions, IHeaderState } from './models';

const OPEN_DRAWER = 'OPEN_DRAWER';
const CLOSE_DRAWER = 'CLOSE_DRAWER';

const initialState: IHeaderState = {
  isDrawerOpened: false,
};

export const reducer = (state: IHeaderState = initialState, action: IHeaderAction) => {
  switch (action.type) {
    case OPEN_DRAWER:
      return {
        ...state,
        isDrawerOpened: true,
      };

    case CLOSE_DRAWER:
      return {
        ...state,
        isDrawerOpened: false,
      };

    default:
      return state;
  }
};

const openDrawer = (): IHeaderAction => ({ type: OPEN_DRAWER });
const closeDrawer = (): IHeaderAction => ({ type: CLOSE_DRAWER });

export const actions: IHeaderActions = {
  openDrawer,
  closeDrawer,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/scenes/Header/reducer.tsx